<template>
  <div>
    <div class="MobileHide">
      <div
        style="
          height: 45px;
          line-height: 45px;
          background: #2c2d31;
          color: #e6e6e6;
        "
      >
        <span style="margin-left: 10px; font-size: 12px">
          {{ $t("LanguageEn.teamInformation") }}
        </span>
      </div>
      <div>
        <div class="container">
          <div
            class="row"
            style="background: #212225; height: 140px; color: #e6e6e6"
          >
            <div class="col" style="line-height: 140px">
              <img
                style="width: 90px; margin-left: 20px; margin-right: 10px"
                :src="teamLogo + id"
              />
              <span style="color: lightgrey">
                {{ name | transliterate(cookiesObject.lang) }}</span
              >
              <img
                v-if="favs.some((fav) => fav.id === id)"
                v-on:click="removeFavorite({ value: id, type: team })"
                :src="favImage1"
                style="
                  width: 15px;
                  cursor: pointer;
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-bottom: 5px;
                "
                alt=""
              />
              <img
                v-else
                v-on:click="addToFavorites({ value: id, type: team })"
                :src="favImage"
                style="
                  width: 15px;
                  cursor: pointer;
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-bottom: 5px;
                "
                alt=""
              />
            </div>
            <div class="col-3" style="padding-top: 35px; font-size: 14px">
              <p style="">
                <router-link
                  id="routerLink"
                  style="
                    padding: 0px !important;
                    text-decoration: none !important;
                  "
                  :to="{ name: 'Ranks', params: { type: ranking4 } }"
                >
                  {{
                    ranking4.toUpperCase() | transliterate(cookiesObject.lang)
                  }}
                  {{ $t("LanguageEn.ranking") }}:
                  {{ ranking1 | transliterate(cookiesObject.lang) }}
                  <img
                    v-if="ranking5 == 'up'"
                    src="@/assets/up.png"
                    style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                    alt=""
                  /><img
                    v-else-if="ranking5 == 'down'"
                    src="@/assets/down.png"
                    style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                    alt=""
                  /><img
                    v-else-if="ranking5 == 'equal'"
                    src="@/assets/dash.png"
                    style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                    alt=""
                  /><span v-else></span><br />
                </router-link>
                {{ $t("LanguageEn.points") }}:
                {{ ranking2 | transliterate(cookiesObject.lang) }} <br />
                <span v-if="ranking4 == 'uefa'">
                  {{ $t("LanguageEn.Coeffiecient") }}:
                  {{ ranking3 | transliterate(cookiesObject.lang) }}</span
                ><br />
                <!-- Rotation:  {{ranking5}} -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="MobileShow" style="">
      <div
        style="
          height: 45px;
          line-height: 45px;
          background: #2c2d31;
          color: #e6e6e6;
        "
      >
        <span style="margin-left: 10px; font-size: 12px">
          {{ $t("LanguageEn.teamInformation") }}
        </span>
      </div>
      <div class="">
        <div
          class=""
          style="background: #212225; height: 140px; color: #e6e6e6"
        >
          <div class="" style="line-height: 105px">
            <img style="width: 80px; margin-left: 10px" :src="teamLogo + id" />
            <span style="color: lightgrey">
              {{ name | transliterate(cookiesObject.lang) }}</span
            >
            <img
              v-if="favs.some((fav) => fav.id === id)"
              v-on:click="removeFavorite({ value: id, type: team })"
              :src="favImage1"
              style="
                width: 15px;
                cursor: pointer;
                margin-left: 10px;
                margin-bottom: 5px;
              "
              alt=""
            />
            <img
              v-else
              v-on:click="addToFavorites({ value: id, type: team })"
              :src="favImage"
              style="
                width: 15px;
                cursor: pointer;
                margin-left: 10px;
                margin-bottom: 5px;
              "
              alt=""
            />
          </div>
          <div class="" style="font-size: 11.5px; margin-left: 10px">
            <p style="">
              <router-link
                id="routerLink"
                style="
                  padding: 0px !important;
                  text-decoration: none !important;
                "
                :to="{ name: 'Ranks', params: { type: ranking4 } }"
              >
                {{ ranking4.toUpperCase() | transliterate(cookiesObject.lang) }}
                {{ $t("LanguageEn.ranking") }}:
                {{ ranking1 | transliterate(cookiesObject.lang) }}
                <img
                  v-if="ranking5 == 'up'"
                  src="@/assets/up.png"
                  style="width: 15px; margin-bottom: 3px; margin-left: 2px"
                  alt=""
                /><img
                  v-else-if="ranking5 == 'down'"
                  src="@/assets/down.png"
                  style="width: 15px; margin-bottom: 3px; margin-left: 2px"
                  alt=""
                /><img
                  v-else-if="ranking5 == 'equal'"
                  src="@/assets/dash.png"
                  style="width: 15px; margin-bottom: 3px; margin-left: 2px"
                  alt=""
                /><span v-else></span>,
              </router-link>
              <span style="margin-left: 5px; margin-right: 5px">
                {{ $t("LanguageEn.points") }}:
                {{ ranking2 | transliterate(cookiesObject.lang) }},
              </span>
              <span v-if="ranking4 == 'uefa'">
                {{ $t("LanguageEn.Coeffiecient") }}:
                {{ ranking3 | transliterate(cookiesObject.lang) }}
              </span>
              <!-- Rotation:  {{ranking5}} -->
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <b-tabs
        v-model="tabIndex"
        class="Some"
        style="border-radius: 0px; color: white; background: #2c2d31"
        nav-class="ks1"
        active-nav-item-class="ks"
        active-tab-class=""
        content-class=""
      >
        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
              v-if="tabIndex == 0"
            >
              {{ $t("LanguageEn.Result") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
              v-else
            >
              {{ $t("LanguageEn.Result") }}
            </p>
          </template>
          <div style="height: 15px; background: #141416"></div>
          <div v-for="(game, count) in gamesHistory" :key="count" style="">
            <ul class="list-group pl-0 pr-0" style="border-radius: 0px">
              <li
                class=""
                style="
                  color: #e6e6e6;
                  font-size: 13px;
                  background: #212225;
                  list-style-type: none;
                  height: 34px;
                  line-height: 34px;
                "
              >
                <span class="MobileHide" style="margin-left: 5px"
                  ><img
                    :src="tournamentLogo + game.tournament.id"
                    style="width: 24px"
                    alt=""
                  />
                  {{ game.tournament.name | transliterate(cookiesObject.lang)
                  }}<img
                    src="@/assets/orStar.png"
                    v-if="favsT.some((fav) => fav.id === game.tournament.id)"
                    v-on:click="
                      removeFavorite({
                        value: game.tournament.id,
                        type: tournament,
                      })
                    "
                    style="
                      width: 15px;
                      margin-bottom: 3px;
                      margin-left: 5px;
                      cursor: pointer;
                    "
                    alt=""
                  />
                  <img
                    v-else
                    v-on:click="
                      addToFavorites({
                        value: game.tournament.id,
                        type: tournament,
                      })
                    "
                    src="@/assets/favorite.svg"
                    style="
                      width: 15px;
                      margin-bottom: 3px;
                      margin-left: 5px;
                      cursor: pointer;
                    "
                    alt=""
                  />
                </span>
                <span class="MobileShow" style="margin-left: 5px"
                  ><img
                    :src="tournamentLogo + game.tournament.id"
                    style="width: 15px; margin-right: 10px"
                    alt=""
                  />
                  {{ game.tournament.name | transliterate(cookiesObject.lang)
                  }}<img
                    src="@/assets/orStar.png"
                    v-if="favsT.some((fav) => fav.id === game.tournament.id)"
                    v-on:click="
                      removeFavorite({
                        value: game.tournament.id,
                        type: tournament,
                      })
                    "
                    style="
                      width: 15px;
                      margin-bottom: 3px;
                      margin-left: 5px;
                      cursor: pointer;
                    "
                    alt=""
                  />
                  <img
                    v-else
                    v-on:click="
                      addToFavorites({
                        value: game.tournament.id,
                        type: tournament,
                      })
                    "
                    src="@/assets/favorite.svg"
                    style="
                      width: 15px;
                      margin-bottom: 3px;
                      margin-left: 5px;
                      cursor: pointer;
                    "
                    alt=""
                  />
                </span>
                <span style="float: right; margin-right: 5px"
                  >{{
                    game.matchTime.slice(0, -9)
                      | transliterate(cookiesObject.lang)
                  }}
                </span>
              </li>
              <li
                class="MobileHide"
                style="
                  background: #141416;
                  list-style-type: none;
                  height: 40px;
                  line-height: 40px;
                  padding-left: 2px;
                "
              >
                <div class="row" style="font-size: 13px">
                  <router-link
                    style="color: #e6e6e6"
                    class="col"
                    id="router-link"
                    :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                  >
                    <div class="row">
                      <div class="col-1 bodyElement" style="padding-left: 20px">
                        <p v-if="game.matchStatus.name == 'FT'">
                          {{ game.matchStatus.name }}
                        </p>
                        <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                        <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                        <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                        <p v-else-if="game.matchStatus.name == 'NS'">
                          {{ game.matchTime.slice(11, 16) }}
                        </p>
                        <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                        <p v-else-if="game.matchStatus.name == 'AWARDED'">
                          AWR
                        </p>
                        <p
                          v-else-if="game.matchStatus.name == 'LIVE'"
                          style=""
                          class="pop"
                        >
                          Live
                          {{
                            calculateMinutes(game.counterStartTime)
                              | transliterate(cookiesObject.lang)
                          }}'
                        </p>
                        <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                        <p v-else>{{ game.matchStatus.name }}</p>
                      </div>
                      <div
                        class="col bodyElement"
                        :style="
                          rtl ? 'text-align: left;' : 'text-align: right;'
                        "
                      >
                        {{
                          game.team1.name.slice(0, 18)
                            | transliterate(cookiesObject.lang)
                        }}
                        <img
                          :src="teamLogo + game.team1.id"
                          alt=""
                          style="width: 20px"
                        />
                      </div>
                      <div
                        class="col-2 bodyElement"
                        v-if="
                          game.matchStatus.name == 'NS' ||
                          game.matchStatus.name == 'POSTP' ||
                          game.matchStatus.name == 'CANCL'
                        "
                        style="letter-spacing: 3px; text-align: center"
                      >
                        -
                      </div>
                      <div
                        class="col-2 bodyElement"
                        style="letter-spacing: 3px; text-align: center"
                        v-else
                      >
                        {{
                          game.currentScore | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div
                        class="col bodyElement"
                        :style="
                          rtl ? 'text-align: right;' : 'text-align: left;'
                        "
                      >
                        <img
                          :src="teamLogo + game.team2.id"
                          alt=""
                          style="width: 20px"
                        />
                        {{
                          game.team2.name.slice(0, 18)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                  </router-link>
                  <div class="col-1 bodyElement">
                    <div>
                      <img
                        src="@/assets/orStar.png"
                        v-if="favsTe.some((fav) => fav.id === game.id)"
                        v-on:click="
                          removeFavorite({ value: game.id, type: match })
                        "
                        style="width: 15px; margin-top: 3px; cursor: pointer"
                        alt=""
                      />
                      <img
                        v-else
                        v-on:click="
                          addToFavorites({ value: game.id, type: match })
                        "
                        src="@/assets/favorite.svg"
                        style="width: 15px; margin-top: 3px; cursor: pointer"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="list-group-item game MobileShow"
                style="background: #141416"
              >
                <div class="row">
                  <router-link
                    class="col"
                    id="router-link"
                    style="color: #e6e6e6"
                    :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                  >
                    <div class="row">
                      <div
                        class="col-1 bodyElement"
                        style="
                          margin-top: 15px;
                          font-size: 11px;
                          padding-right: 20px;
                          color: grey;
                        "
                      >
                        <p v-if="game.matchStatus.name == 'FT'">
                          {{ game.matchStatus.name }}
                        </p>
                        <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                        <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                        <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                        <p v-else-if="game.matchStatus.name == 'NS'">
                          {{ game.matchTime.slice(11, 16) }}
                        </p>
                        <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                        <p v-else-if="game.matchStatus.name == 'AWARDED'">
                          AWR
                        </p>
                        <p
                          v-else-if="game.matchStatus.name == 'LIVE'"
                          class="pop"
                        >
                          {{ calculateMinutes(game.counterStartTime) }}'
                        </p>
                        <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                        <p v-else>{{ game.matchStatus.name }}</p>
                      </div>
                      <div
                        class="col"
                        style="
                          text-align: left;
                          font-size: 14px;
                          margin-top: 4px;
                        "
                      >
                        <div class="bodyElement" style="margin-bottom: 10px">
                          <img
                            :src="teamLogo + game.team1.id"
                            alt=""
                            style="width: 12px; margin-right: 4px"
                          />{{
                            game.team1.name.slice(0, 20)
                              | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div class="bodyElement">
                          <img
                            :src="teamLogo + game.team2.id"
                            alt=""
                            style="width: 12px; margin-right: 4px"
                          />{{
                            game.team2.name.slice(0, 20)
                              | transliterate(cookiesObject.lang)
                          }}
                        </div>
                      </div>
                      <div
                        class="col-1"
                        v-if="game.matchStatus.name == 'NS'"
                        style="font-weight: 400; margin-top: 4px"
                      >
                        <div style="margin-bottom: 15px">?</div>
                        <div>?</div>
                      </div>
                      <div class="col-1" v-else style="margin-top: 4px">
                        <div style="margin-bottom: 15px">
                          {{
                            game.currentScore.slice(0, 1)
                              | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div>
                          {{
                            game.currentScore.slice(2, 3)
                              | transliterate(cookiesObject.lang)
                          }}
                        </div>
                      </div>
                    </div>
                  </router-link>
                  <div class="col-1 bodyElement" style="margin-top: 4px">
                    <div>
                      <img
                        v-if="favsTe.some((fav) => fav.id === game.id)"
                        v-on:click="
                          removeFavorite({ value: game.id, type: match })
                        "
                        src="@/assets/orStar.png"
                        style="width: 16px; margin-top: 5px; margin-left: -5px"
                        alt=""
                      />
                      <img
                        v-else
                        v-on:click="
                          addToFavorites({ value: game.id, type: match })
                        "
                        src="@/assets/favorite.svg"
                        style="width: 16px; margin-top: 5px; margin-left: -5px"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            style="
              padding-top: 10px;
              padding-bottom: 10px;
              text-align: center;
              background: #141416;
            "
          >
            <b-btn
              variant="success"
              style="width: 200px; border-radius: 0px; background: #1c5e20"
              v-on:click="pageCount++, addGames()"
              >{{ $t("LanguageEn.moreGames") }}</b-btn
            >
          </div>
        </b-tab>
        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
              v-if="tabIndex == 1"
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
              v-else
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
          </template>

          <div class="" style="text-align: left; background: #141416">
            <div>
              <div style="color: whitesmoke">
                <div class="container">
                  <div class="row">
                    <b-form-select
                      v-model="year"
                      class="mb-3 col mr-1"
                      @change="filter(year)"
                      style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option
                        v-for="i in ex"
                        :key="i.id"
                        :value="i.id"
                        >{{ i.y | transliterate(cookiesObject.lang) }}
                        {{
                          i.name | transliterate(cookiesObject.lang)
                        }}</b-form-select-option
                      >
                    </b-form-select>

                    <b-form-select
                      v-model="chstat"
                      class="mb-3 col ml-1"
                      style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option :value="1">{{
                        $t("LanguageEn.mStatistics")
                      }}</b-form-select-option>
                      <b-form-select-option :value="2">{{
                        $t("LanguageEn.sDetails")
                      }}</b-form-select-option>
                      <b-form-select-option :value="3">{{
                        $t("LanguageEn.sGoal")
                      }}</b-form-select-option>
                      <b-form-select-option :value="4">{{
                        $t("LanguageEn.STiming")
                      }}</b-form-select-option>
                    </b-form-select>
                  </div>
                </div>

                <div v-if="chstat == 1">
                  <li
                    class="row MobileHide"
                    style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col-6"> {{ $t("LanguageEn.details") }} </span>
                    <span class="col">{{ $t("LanguageEn.result") }} </span>
                  </li>
                  <li
                    class="row MobileShow"
                    style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col"> {{ $t("LanguageEn.details") }} </span>
                    <span class="col-2 mr-2" style="text-align: right"
                      >{{ $t("LanguageEn.result") }}
                    </span>
                  </li>
                  <div v-for="(s, ix) in testarr" :key="ix">
                    <div v-for="(item, i) in s" :key="i">
                      <!-- <p v-if="item.season.id == bst">{{item.dataKey}} - {{item.dataValue}}</p> -->
                      <li
                        class="row MobileHide"
                        v-if="item.season.id == year"
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col-6" style="color: grey">
                          {{ item.dataKey | transliterate(cookiesObject.lang) }}
                        </span>
                        <span class="col"
                          >{{
                            item.dataValue | transliterate(cookiesObject.lang)
                          }}
                        </span>
                      </li>
                      <li
                        class="row MobileShow"
                        v-if="item.season.id == year"
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col" style="color: grey">
                          {{ item.dataKey | transliterate(cookiesObject.lang) }}
                        </span>
                        <span class="col-2" style="text-align: right"
                          >{{
                            item.dataValue | transliterate(cookiesObject.lang)
                          }}
                        </span>
                      </li>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 2">
                  <li
                    class="row MobileHide"
                    style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col-6" style="font-size: 16px"
                      >{{ $t("LanguageEn.category") }}
                    </span>
                    <span class="col">{{ $t("LanguageEn.home") }} </span
                    ><span class="col">{{ $t("LanguageEn.away") }} </span
                    ><span class="col">{{ $t("LanguageEn.total") }} </span>
                  </li>
                  <li
                    class="row MobileShow"
                    style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col"> {{ $t("LanguageEn.category") }} </span>
                    <span class="col-2 mr-2" style="text-align: right"
                      >{{ $t("LanguageEn.total") }}
                    </span>
                  </li>
                  <div v-for="(s, inx) in testarr2" :key="inx">
                    <div v-for="(item, ind) in s" :key="ind">
                      <li
                        class="row MobileHide"
                        v-if="item.season.id == year"
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col-6" style="color: grey">
                          {{
                            item.category.replace(/_/g, " ")
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span class="col"
                          >{{
                            item.home | transliterate(cookiesObject.lang)
                          }} </span
                        ><span class="col"
                          >{{
                            item.away | transliterate(cookiesObject.lang)
                          }} </span
                        ><span class="col"
                          >{{ item.total | transliterate(cookiesObject.lang) }}
                        </span>
                      </li>
                      <li
                        class="row MobileShow"
                        v-if="item.season.id == year"
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col" style="color: grey">
                          {{
                            item.category.replace(/_/g, " ")
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span class="col-2" style="text-align: right"
                          >{{ item.total | transliterate(cookiesObject.lang) }}
                        </span>
                      </li>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 3">
                  <li
                    class="row"
                    style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span
                      v-bind:class="{ gcl: haw == 'home' }"
                      class="col-3"
                      @click="haw = 'home'"
                      style="cursor: pointer"
                      >{{ $t("LanguageEn.home") }}
                    </span>
                    <span
                      style="cursor: pointer"
                      v-bind:class="{ gcl: haw == 'away' }"
                      class="col-2 ml-0 pl-0"
                      @click="haw = 'away'"
                      >{{ $t("LanguageEn.away") }}
                    </span>
                  </li>
                  <div v-for="(s, ik) in testarr3" :key="ik">
                    <div v-for="(item, sik) in s" :key="sik">
                      <div
                        class="container"
                        v-if="item.venue == haw && item.direction == 'under'"
                      >
                        <p
                          class="row"
                          style="
                            text-align: center;
                            font-size: 14px;
                            margin-top: 10px;
                          "
                        >
                          <span class="col"
                            >{{
                              item.value | transliterate(cookiesObject.lang)
                            }}%</span
                          >
                          <span class="col"
                            >{{
                              item.minutes.replace(/_/g, ".")
                                | transliterate(cookiesObject.lang)
                            }}
                            Goals
                          </span>
                          <span class="col"
                            >{{
                              (100 - item.value).toFixed(2)
                                | transliterate(cookiesObject.lang)
                            }}%</span
                          >
                        </p>
                        <b-progress
                          class=""
                          :max="200"
                          style="
                            border-radius: 0px;
                            height: 11px;
                            background: #2c2d31;
                          "
                        >
                          <b-progress-bar
                            style="font-weight: 800px; background: #2c2d31"
                            :value="100 - item.value"
                            variant=""
                          ></b-progress-bar>
                          <b-progress-bar
                            style="
                              font-weight: 800px;
                              background: #5c5c5e;
                              border-right: 1px solid #2c2d31;
                            "
                            v-bind:class="{ ybg: item.value > 50 }"
                            :value="item.value"
                            variant=""
                          ></b-progress-bar>
                          <b-progress-bar
                            style="
                              font-weight: 800px;
                              background: #5c5c5e;
                              border-left: 1px solid #2c2d31;
                            "
                            v-bind:class="{ ybg: 100 - item.value > 50 }"
                            :value="100 - item.value"
                          ></b-progress-bar>
                          <b-progress-bar
                            style="font-weight: 800px; background: #2c2d31"
                            :value="item.value"
                            variant=""
                          ></b-progress-bar>
                        </b-progress>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 4">
                  <!-- <div v-for="s in testarr4" :key="s.id">
              <div v-for="item in s" :key="item.id">
              
              </div>
          </div> -->
                  <li
                    class="row"
                    style="
                      color: #e6e6e6;
                      margin-bottom: 10px;
                      margin-left: 0px;
                      margin-right: 0px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span
                      v-bind:class="{ gcl: sc == 1 }"
                      class="col-3"
                      @click="sc = 1"
                      style="cursor: pointer"
                      >{{ $t("LanguageEn.scored") }}
                    </span>
                    <span
                      style="cursor: pointer"
                      v-bind:class="{ gcl: sc == 2 }"
                      class="col-2 ml-0 pl-0"
                      @click="sc = 2"
                      >{{ $t("LanguageEn.conceded") }}
                    </span>
                  </li>

                  <area-chart
                    v-if="sc == 1"
                    xtitle="Minutes"
                    ytitle="Goals"
                    :colors="['rgba(67, 160, 71, 0.5)']"
                    :data="{
                      '0-15': testarr5[0].count,
                      '15-30': testarr5[1].count,
                      '30-45': testarr5[2].count,
                      '45-60': testarr5[3].count,
                      '60-75': testarr5[4].count,
                      '75-90': testarr5[5].count,
                    }"
                  >
                  </area-chart>
                  <area-chart
                    v-else
                    xtitle="Minutes"
                    ytitle="Goals"
                    :colors="['rgba(208, 73, 89, 0.5)']"
                    :data="{
                      '0-15': testarr6[0].count,
                      '15-30': testarr6[1].count,
                      '30-45': testarr6[2].count,
                      '45-60': testarr6[3].count,
                      '60-75': testarr6[4].count,
                      '75-90': testarr6[5].count,
                    }"
                  >
                  </area-chart>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
              v-if="tabIndex == 2"
            >
              {{ $t("LanguageEn.archive") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
              v-else
            >
              {{ $t("LanguageEn.archive") }}
            </p>
          </template>
          <div class="">
            <li
              v-if="leaderList.length == 0"
              class="list-group-item listHeader"
              style="
                border-radius: 0px;
                background: #212225;
                font-size: 12px;
                color: #e6e6e6;
                height: 40px;
              "
            >
              <img style="margin-bottom: 3px" src="@/assets/noInfo.svg" />{{
                $t("LanguageEn.noInfoa")
              }}
            </li>
            <div v-else>
              <div
                v-for="(some, i) in leaderList"
                :key="i"
                style="
                  border: none;
                  font-size: 12px;
                  background: #141416;
                  list-style-type: none;
                "
                class=""
              >
                <div style="padding-top: 15px">
                  <li
                    style="
                      font-size: 14px;
                      color: #e6e6e6;
                      background: #212225;
                      padding: 5px;
                      font-weight: bold;
                    "
                  >
                    {{
                      some[0].league.name | transliterate(cookiesObject.lang)
                    }}
                  </li>
                </div>
                <span v-for="(so, ind) in some" :key="ind" style="">
                  <p
                    style="padding-top: 10px; padding-bottom: 0px"
                    v-if="ind == 0"
                  >
                    {{ "Winner" | transliterate(cookiesObject.lang) }}
                  </p>
                  <span v-if="so.status == 'Winner'">
                    <span
                      style="margin-right: 5px"
                      v-if="so.seasonName != null"
                    >
                      {{ so.seasonName | transliterate(cookiesObject.lang) }},
                    </span>
                    <span
                      style="
                        padding-top: 5px;
                        padding-bottom: 5px;
                        margin-right: 3px;
                      "
                      v-else
                    >
                      {{ so.season.name | transliterate(cookiesObject.lang) }},
                    </span>
                  </span>
                </span>
                <span v-for="(so, indx) in some" :key="so.seasonName" style="">
                  <p
                    style="padding-top: 10px; padding-bottom: 0px"
                    v-if="indx == 0"
                  >
                    {{ "Runner-up" | transliterate(cookiesObject.lang) }}
                  </p>
                  <span v-if="so.status == 'Runner-up'">
                    <span
                      style="margin-right: 5px"
                      v-if="so.seasonName != null"
                    >
                      {{ so.seasonName | transliterate(cookiesObject.lang) }},
                    </span>
                    <span
                      style="
                        padding-top: 5px;
                        padding-bottom: 5px;
                        margin-right: 3px;
                      "
                      v-else
                    >
                      {{ so.season.name | transliterate(cookiesObject.lang) }},
                    </span>
                  </span>
                </span>

                <!-- <div class="">
                  <div class="col mr-0 pr-0" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <img :src="tournamentLogo + some.league.id" alt="" style="width: 24px; margin-right: 3px; background: #E6E6E6; border-radius: 50%; padding: 2px;"> <span class="MobileHide"> {{some.league.name}}</span> <span class="MobileShow"> {{some.league.name.slice(0,14)}} <span v-if="some.league.name.length > 15">.</span></span>
                </div>
                 <div class="col-4" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <span>{{some.seasonName}}</span>
                </div>
                <div class="col-3 mr-0" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.status}}
                </div>
            </div> -->
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
              v-if="tabIndex == 3"
            >
              {{ "Squad" | transliterate(cookiesObject.lang) }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
              v-else
            >
              {{ "Squad" | transliterate(cookiesObject.lang) }}
            </p>
          </template>
          <div class="" style="text-align: left; background: #141416">
            <div>
              <div style="color: whitesmoke">
                <div class="container">
                  <div class="row">
                    <b-form-select
                      v-model="sqyear"
                      class="mb-3 col-6"
                      @change="squadup(sqyear)"
                      style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option
                        v-for="i in seasList"
                        :key="i.id"
                        :value="i.id"
                        >{{ i.name | transliterate(cookiesObject.lang) }}
                        {{
                          i.tournament.name | transliterate(cookiesObject.lang)
                        }}</b-form-select-option
                      >
                    </b-form-select>
                  </div>
                </div>

                <div>
                  <!-- 
            <li class="list-group-item infoItem" v-for="lineup in squad" :key="lineup.id" style="border-radius: 0px; border-right: none; background: #141416; border-bottom: 1px solid #2c2d31;">
              <div class="row" style="">
                <div class="col">
                <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: lineup.player.id} }">
                  <span class="col-1 " style="padding-top: 7px;">{{lineup.squadData.number}}</span>  
                  <span class="col ml-1" style="padding-top: 5px;" v-if="lineup.player.shortName" > <img v-if="lineup.player.country" :src="categoryLogo + lineup.player.country.id" style="width: 18px; border-radius: 2px; margin-right: 5px;" alt=""> {{lineup.player.shortName}}</span> 
                  <span class="col ml-1" style="padding-top: 5px;" v-else> <img v-if="lineup.player.country" :src="categoryLogo + lineup.player.country.id" style="width: 18px; border-radius: 2px; margin-right: 5px;" alt=""> {{lineup.player.commonName}}</span> 
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.appearences"> {{lineup.squadData.appearences}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.goals"> {{lineup.squadData.goals}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.assists"> {{lineup.squadData.assists}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                </router-link>
              </div>
              </div>
              </li> -->

                  <div class="container">
                    <div
                      class="row"
                      style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> GK </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(cookiesObject.lang) }}
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/CS.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/spg.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    v-for="lineup in squad1"
                    :key="lineup.squadData.shortName"
                    style="
                      border-radius: 0px;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                          lineup.squadData.number
                            | transliterate(cookiesObject.lang)
                        }}</span>
                        <span
                          class="col pl-1"
                          style="padding-top: 5px"
                          v-if="lineup.player.shortName"
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.shortName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.commonName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.cleansheets">
                            {{
                              lineup.squadData.cleansheets
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span
                            v-if="
                              lineup.squadData.saves &&
                              lineup.squadData.appearences
                            "
                          >
                            {{
                              (
                                lineup.squadData.saves /
                                lineup.squadData.appearences
                              ).toFixed(1) | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                      class="row"
                      style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> DF </span>
                      <span class="col pl-1">{{
                        "Name" | transliterate(cookiesObject.lang)
                      }}</span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    v-for="lineup in squad2"
                    :key="lineup.squadData.shortName"
                    style="
                      border-radius: 0px;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                          lineup.squadData.number
                            | transliterate(cookiesObject.lang)
                        }}</span>
                        <span
                          class="col pl-1"
                          style="padding-top: 5px"
                          v-if="lineup.player.shortName"
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.shortName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.commonName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                      class="row"
                      style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> MF </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(cookiesObject.lang) }}
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    v-for="lineup in squad3"
                    :key="lineup.squadData.shortName"
                    style="
                      border-radius: 0px;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                          lineup.squadData.number
                            | transliterate(cookiesObject.lang)
                        }}</span>
                        <span
                          class="col pl-1"
                          style="padding-top: 5px"
                          v-if="lineup.player.shortName"
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.shortName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.commonName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                      class="row"
                      style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> FW </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(cookiesObject.lang) }}
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                          style="width: 24px; margin-bottom: 4px"
                          src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    v-for="lineup in squad4"
                    :key="lineup.squadData.shortName"
                    style="
                      border-radius: 0px;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                          lineup.squadData.number
                            | transliterate(cookiesObject.lang)
                        }}</span>
                        <span
                          class="col pl-1"
                          style="padding-top: 5px"
                          v-if="lineup.player.shortName"
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.shortName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                          ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                          />
                          <router-link
                            style="color: white"
                            :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                            ><span class="MobileShow">
                              {{
                                lineup.player.commonName.slice(0, 12)
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                | transliterate(cookiesObject.lang)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "teamPage",
  data() {
    return {
      gamesHistory: [],
      id: "",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      tournamentLogo: "https://sportapi.zuniac.com/tournament/logo/",
      categoryLogo: "https://sportapi.zuniac.com/category/logo/",
      playerLogo: "https://sportapi.zuniac.com/player/logo/",
      name: "",
      cookiesObject: "",
      showDismissibleAlert: false,
      favImage: require("@/assets/favorite1.png"),
      favImage1: require("@/assets/orStar.png"),
      team: "team",
      tabIndex: 0,
      match: "match",
      tournament: "tournament",
      teamSeasonStatistics: "",
      teamSeasonStatisticsDetails: "",
      teamSeasonGoalLines: "",
      teamSeasonTimings: "",
      leaderList: "",
      testarr: "",
      testarr2: "",
      testarr3: "",
      testarr4: "",
      testarr5: "",
      testarr6: "",
      groups2: "",
      groups3: "",
      ranking: "",
      ranking1: "",
      ranking2: "",
      ranking3: "",
      ranking4: "uefa",
      ranking5: "",
      ex: "",
      year: "",
      chstat: 1,
      pageCount: 1,
      haw: "home",
      sc: 1,
      seasList: [],
      sqyear: "",
      squad: [],
      squad1: [],
      squad2: [],
      squad3: [],
      squad4: [],
      pressed: true,
    };
  },
  async mounted() {
    this.id = this.$route.params.id;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    this.fixtureData();
    this.getList();

    var offset = new Date().getTimezoneOffset();

    if (cookiesObject.token) {
      var res = await fetch(
        this.httpReq +
          "/team/matches?langId=" +
          this.cookiesObject.langId +
          "&portalId=" +
          (cookiesObject.portalId ? cookiesObject.portalId : 0) +
          "&teamId=" +
          this.id +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00&token=" +
          cookiesObject.token
      );
      var data = await res.json();
      if (data.ranking.length > 0) {
        this.ranking = data.ranking[0];
        this.ranking1 = data.ranking[0].position;
        this.ranking2 = data.ranking[0].points;
        this.ranking3 = data.ranking[0].coeffiecient;
        this.ranking4 = data.ranking[0].ranking;
        this.ranking5 = data.ranking[0].positionStatus;
      }
      var gamesHistory = data.matches;
      this.gamesHistory = gamesHistory;
      this.name = data.team.name;

      if (data.code == 200) {
        //everything is okay
      } else if (data.code == 401) {
        alert(this.$t("LanguageEn.logText"));
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 404) {
        alert("Token is not valid and portal id not provided");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 500) {
        alert("Oops, something went wrong!");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else {
        alert("service error");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }
    } else {
      var resp = await fetch(
        this.httpReq +
          "/team/matches?langId=" +
          this.cookiesObject.langId +
          "&portalId=" +
          (cookiesObject.portalId ? cookiesObject.portalId : 0) +
          "&teamId=" +
          this.id +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00"
      );
      var datas = await resp.json();
      var gamesHistorys = datas.matches;
      this.gamesHistory = gamesHistorys;
      this.name = data.team.name;
    }

    var seasListc = await fetch(
      this.httpReq + "/team/" + this.id + "/squad/seasons"
    );
    var seasList = await seasListc.json();
    this.seasList = seasList.seasons.reverse();

    this.sqyear = seasList.seasons[0].id;
    this.squadup(this.sqyear);
  },

  components: {},
  props: {},
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
    async addGames() {
      var offset = new Date().getTimezoneOffset();

      var res = await fetch(
        this.httpReq +
          "/team/matches?page=" +
          this.pageCount +
          "&langId=" +
          this.cookiesObject.langId +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&teamId=" +
          this.id +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00&token=" +
          this.cookiesObject.token
      );
      var data = await res.json();

      var gamesHistory = data.matches;
      this.gamesHistory = this.gamesHistory.concat(gamesHistory);
      this.name = data.team.name;

      this.$forceUpdate();
    },
    fixtureData() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/team/" +
          this.id +
          "/statistics?token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          var path = ["season", "id"]; // by this nested item property array will be grouped

          var groups = result.teamSeasonStatistics.reduce(function (
            groups,
            item
          ) {
            var name = path.reduce(function (data, key) {
              return data[key];
            }, item);

            var group = groups[name] || (groups[name] = []);
            group.push(item);

            return groups;
          },
          {});

          const select = Object.keys(groups).map((gid) => {
            const g = groups[gid];
            return {
              id: g[0].season.id,
              y: g[0].season.name,
              name: g[0].season.tournament.name,
            };
          });

          // console.log(select);

          this.testarr = groups;
          this.ex = select.reverse();
          // console.log(Object.values(groups));
          // console.log(result);
          // console.log(groups);
          // console.log(groups[Object.keys(groups)[0]]);
          this.year = this.ex[0].id;

          // for(var key in groups) {
          //   var group = groups[key];
          //   console.log((group));
          // }

          // 2nd section

          var groups1 = result.teamSeasonStatisticsDetails.reduce(function (
            groups,
            item
          ) {
            var name = path.reduce(function (data, key) {
              return data[key];
            }, item);

            var group = groups[name] || (groups[name] = []);
            group.push(item);

            return groups;
          },
          {});

          // console.log(groups)
          this.testarr2 = groups1;

          // 3rd section

          var groups2 = result.teamSeasonGoalLines.reduce(function (
            groups,
            item
          ) {
            var name = path.reduce(function (data, key) {
              return data[key];
            }, item);

            var group = groups[name] || (groups[name] = []);
            group.push(item);

            return groups;
          },
          {});
          this.groups2 = groups2;

          let groupT = groups2[this.year].reduce((r, a) => {
            r[a.minutes] = [...(r[a.minutes] || []), a];
            return r;
          }, {});

          // console.log(groups2)
          this.testarr3 = groupT;

          // 4th section
          var groups3 = result.teamSeasonTimings.reduce(function (
            groups,
            item
          ) {
            var name = path.reduce(function (data, key) {
              return data[key];
            }, item);

            var group = groups[name] || (groups[name] = []);
            group.push(item);

            return groups;
          },
          {});

          this.groups3 = groups3;

          let groupT1 = groups3[this.year].reduce((r, a) => {
            r[a.category] = [...(r[a.category] || []), a];
            return r;
          }, {});

          // console.log(groups2)
          this.testarr4 = groupT1;
          this.testarr5 = this.testarr4["scoring_minutes"];
          this.testarr6 = this.testarr4["goals_conceded_minutes"];
          // console.log(groups)
        })
        .catch((error) => console.log("error", error));
    },
    filter(i) {
      let groupT = this.groups2[i].reduce((r, a) => {
        r[a.minutes] = [...(r[a.minutes] || []), a];
        return r;
      }, {});

      // console.log(groups2)
      this.testarr3 = groupT;

      let groupT1 = this.groups3[i].reduce((r, a) => {
        r[a.category] = [...(r[a.category] || []), a];
        return r;
      }, {});

      // console.log(groups2)
      this.testarr4 = groupT1;
      this.testarr5 = this.testarr4["scoring_minutes"];
      this.testarr6 = this.testarr4["goals_conceded_minutes"];
      // console.log(groups)
      // console.log(this.testarr5)
    },
    // testsm(val){
    //   const keyify = (obj, prefix = '') =>
    //   Object.keys(obj).reduce((res, el) => {
    //     if( Array.isArray(obj[el]) ) {
    //       return res;
    //     } else if( typeof obj[el] === 'object' && obj[el] !== null ) {
    //       return [...res, ...keyify(obj[el], prefix + el + '.')];
    //     }
    //     return [...res, prefix + el];
    //   }, []);

    // const input = val;

    // const output = keyify(input);

    // console.log(output);
    // },
    getList() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=df2a91fbe41d157df37eda10912805fd81618232247"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/team/" +
          this.id +
          "/standings?token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // console.log(result.teamTrophies)
          var path = ["league", "name"]; // by this nested item property array will be grouped

          var groups = result.teamTrophies.reduce(function (groups, item) {
            var name = path.reduce(function (data, key) {
              return data[key];
            }, item);

            var group = groups[name] || (groups[name] = []);
            group.push(item);

            return groups;
          }, {});

          this.leaderList = groups;
        })
        .catch((error) => console.log("error", error));
    },
    calculateMinutes(value) {
      if (value == null) {
        return "LIVE";
      } else {
        var startDate = new Date(value.replace(" ", "T"));
        var endDate = Date.now();
        var difference = (endDate - startDate) / 1000 / 60;

        if (difference < 0) {
          difference = difference + 240;
        }

        return parseInt(difference);
      }
    },

    async squadup(val) {
      var res = await fetch(
        this.httpReq + "/team/" + this.id + "/squad?seasonId=" + val
      );
      var data = await res.json();

      this.squad = data.seasons;

      this.squad = this.squad.filter((p) => p.squadData.number);

      this.squad1 = this.squad.filter((p) => p.squadData.position_id == 1);
      this.squad1 = this.squad1.sort(function (a, b) {
        const valueA = a.squadData.appearences || 0;
        const valueB = b.squadData.appearences || 0;

        return valueB - valueA;
      });

      this.squad2 = this.squad.filter((p) => p.squadData.position_id == 2);
      this.squad2 = this.squad2.sort(function (a, b) {
        const valueA = a.squadData.appearences || 0;
        const valueB = b.squadData.appearences || 0;

        return valueB - valueA;
      });

      this.squad3 = this.squad.filter((p) => p.squadData.position_id == 3);
      this.squad3 = this.squad3.sort(function (a, b) {
        const valueA = a.squadData.appearences || 0;
        const valueB = b.squadData.appearences || 0;

        return valueB - valueA;
      });

      this.squad4 = this.squad.filter((p) => p.squadData.position_id == 4);
      this.squad4 = this.squad4.sort(function (a, b) {
        const valueA = a.squadData.appearences || 0;
        const valueB = b.squadData.appearences || 0;

        return valueB - valueA;
      });

      console.log(this.squad4);
      this.$forceUpdate();
    },
  },

  computed: {
    ...mapGetters(["favs", "favsTe", "httpReq", "favsT", "rtl"]),
  },
};
</script>

<style scoped>
.Loc {
  background: #212226;
  width: 100%;
  height: 250px;
  margin-bottom: 10px;
}

.pop {
  animation: color-change 1.2s infinite;
}
@keyframes color-change {
  0% {
    color: #a43d4a;
  }
  50% {
    color: red;
  }
  100% {
    color: #a43d4a;
  }
}

.leagueNam {
  text-align: center;
  padding-top: 70px;
  font-size: 18px;
  color: white;
}
.ybg {
  font-weight: 800px;
  background: #be8733 !important;
}
.gcl {
  font-weight: 800px;
  color: #419b45 !important;
}

/* Navbar (info, H2H, etc.) */

.navDiv2 {
  width: 100%;
  height: 60px;
  color: white;
  background-image: linear-gradient(#fefefe, #c3c3c3);
}

#topheader2 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader2 .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #39b54a);
  color: #fff !important;
}

#topheader2 .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

#routerLink {
  /* padding-top: 10%; */
  display: inline-block;
  text-decoration: none;
  color: #e6e6e6;
  /* margin-top: -8px; */
}
#routerLink .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #1b5f20);
  color: #fff !important;
}

#routerLink .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}
.list-group-item {
  line-height: 5px;
}

.listHeader {
  background: #212225;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.infoItem {
  background: #141416;
  color: white;
  /* height: 60px; */
  border-radius: 0px;
  border: none;
}

.circle {
  /* background: #333333; */
  width: 40px;
  height: 40px;
}

.Draw {
  background: #dc2426;
}
#router-link,
#router-link:visited,
#router-link:active,
#router-link:focus {
  text-decoration: none;
  border: 0;
  outline: 0;
}
@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.custom-select {
  background: #212225
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='grey' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
}
</style>